import React from 'react';
import {
    ControlsCell,
    StatusCell,
    PersonCell,
    DepartmentCell,
    OrganizationPostCell,
    Wrapper,
} from './card-employee-list-item-preview.styles';
import { Button, Tag, Tooltip } from '@vtbhome/juicyfront';
import { StatusInfoOutline } from '@vtbhome/juicyfront/indexIcon';
import { UserProfile } from '@shared/ui/user-profile/user-profile';
import { CardEmployeeListItemPreviewProps } from './types';
import { Typography } from '@shared/ui/typography/typography';
import { STATUS_MAP } from './constants';
import { getUserStatus } from '@shared/lib/utils/get-user-status/get-user-status';
import { userName } from '@shared/lib/utils/user-name/user-name';

export const CardEmployeeListItemPreview: React.FC<CardEmployeeListItemPreviewProps> = ({
    user,
    hasBorder = true,
    onInfo,
}) => {
    const statusData = STATUS_MAP[getUserStatus(user)];
    const name = userName({
        firstName: user.firstName,
        lastName: user.lastName,
        middleName: user.middleName,
    });

    return (
        <Wrapper hasBorder={hasBorder}>
            <PersonCell>
                <Typography size='body2_long' color='neutral_50'>
                    Сотрудник
                </Typography>
                <UserProfile
                    text={name.short}
                    avatarUrl={user.photoUrl}
                    size='s'
                    tooltipData={{
                        avatarUrl: user.photoUrl,
                        name: name.full,
                        department: user.department?.name || '-',
                        jobPost: user.jobTitle,
                        email: user.email,
                    }}
                />
            </PersonCell>
            <OrganizationPostCell>
                <Typography size='body2_long' color='neutral_50'>
                    Должность
                </Typography>
                <Typography size='body2_long' color='neutral_90'>
                    {user.jobTitle}
                </Typography>
            </OrganizationPostCell>
            <DepartmentCell>
                <Typography size='body2_long' color='neutral_50'>
                    Отдел
                </Typography>
                <Typography size='body2_long' color='neutral_90'>
                    {user.department?.name || '-'}
                </Typography>
            </DepartmentCell>
            <StatusCell>
                <Typography size='body2_long' color='neutral_50'>
                    Статус
                </Typography>
                {statusData && <Tag variant={statusData.variant}>{statusData.text}</Tag>}
            </StatusCell>
            <ControlsCell>
                <Tooltip>
                    <Button
                        size='s'
                        buttonType='secondary'
                        startAdornment={<StatusInfoOutline size='xxs' />}
                        onClick={onInfo}
                    />
                    <Typography size='body2_short' align='center'>{`Информация\nо сотруднике`}</Typography>
                </Tooltip>
            </ControlsCell>
        </Wrapper>
    );
};
